module.exports = __webpack_public_path__ + "static/media/S-15-Y.a8d38d31.mp3";